"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDialog = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const AlertDialog = props => {
    const { onOkPress, onCancelPress, children, cancelText, okText, title, disabled } = props;
    const alertStyles = useAlertStyles();
    return (react_1.default.createElement(core_1.Dialog, { open: true, className: alertStyles.dialogBox, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        title && react_1.default.createElement(core_1.DialogTitle, null, title),
        react_1.default.createElement(core_1.DialogContent, { style: { lineHeight: 1.5 } }, children),
        react_1.default.createElement(core_1.DialogActions, null,
            onCancelPress && (react_1.default.createElement(core_1.Button, { focusRipple: false, className: alertStyles.btn, onClick: onCancelPress, color: "primary", autoFocus: true }, cancelText)),
            onOkPress && (react_1.default.createElement(core_1.Button, { className: alertStyles.btn, onClick: onOkPress, color: "primary", disabled: disabled },
                react_1.default.createElement(react_1.default.Fragment, null, okText || 'Ok'))))));
};
exports.AlertDialog = AlertDialog;
const useAlertStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    dialogBox: {
        '& .MuiPaper-root.MuiDialog-paper': {
            minWidth: 500,
            [theme.breakpoints.down('xs')]: {
                minWidth: '80vw',
                maxWidth: '90vw',
            },
        },
    },
    btn: {
        color: theme.palette.info.main,
        letterSpacing: '1.25px',
        fontWeight: 500,
        fontSize: 14,
    },
    text: {
        marginBottom: 4,
    },
}));
//# sourceMappingURL=AlertDialog.js.map